import { Route } from "@angular/router";
import { SolicitarTransferenciaPage } from "./solicitar-transferencia.page";

export const SolicitarTransferenciaRouter: Route[] = [
  { path: 'solicitar-transferencia', component: SolicitarTransferenciaPage }
];
